enum AlertType {
  info = 'info',
  success = 'success',
  warning = 'warning',
  danger = 'danger',
}

export { AlertType }
